import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 314px;
  border-radius: 10px;
`;
